export default function() {
    const navbar = document.querySelector('.navbar');
    const quickContact = document.querySelector('#header');
    if (window.pageYOffset > 36) {
        navbar.classList.add('fixed-top', 'bg-solid');
        //quickContact.classList.add('fixed-navbar-contact');
    } else {
        navbar.classList.remove('fixed-top', 'bg-solid');
        //quickContact.classList.remove('fixed-navbar-contact');
    }
};





// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/modules/fixNav.js